/* eslint-disable operator-linebreak */
/* eslint-disable implicit-arrow-linebreak */
/* eslint-disable no-return-assign */
import React from 'react';
import ReactDOM from 'react-dom';
import { styled } from 'twin.macro';
import { WonderSteps } from '../../../../player/components/OneSongWonder';
import hideModal from '../../../../styles/js/modals';

const ModalHeader = styled.div`
  display: flex;
  justify-content: space-between;
  h1 {
    font-size: 22px;
    color: #7687c2;
    font-weight: 700;
    font-family: 'Arial Regular', Arial, sans-serif;
  }
`;

const ModalBody = styled.div`
  font-family: 'Arial Regular', Arial, sans-serif;
  margin-top: 30px;
  .line-header {
    font-size: 13px;
    color: #333333;
  }
  .line {
    font-family: 'Arial Bold', Arial, sans-serif;
    font-size: 24px;
    color: #363636;
    font-style: italic;
    font-weight: 700;
    margin-top: 8px;
  }
  .objective {
    font-weight: 700;
    font-size: 18px;
    color: #333333;
  }
`;

const WonderLineSteps = styled.div`
  display: flex;
  flex-direction: column;
  gap: 18px;
`;

export const Step = styled.button`
  width: 100%;
  height: 46px;
  border-radius: 10px;
  border: 1px solid #7687c2;
  display: flex;
  align-items: center;
  padding-left: 13px;
  background-color: #7687c2;
  position: relative;
  svg {
    color: #ffffff;
    width: 24px;
    height: 24px;
  }
  p {
    color: #ffffff;
    font-weight: 700;
    text-transform: capitalize;
    margin: 0;
    margin-left: 12px;
    font-size: 16px;
  }
`;

const WonderListModal = ({ setSelectedStep }) => {
  const modalContent = (
    <div
      className="modal fade"
      id="wonder-list-modal"
      tabIndex="-1"
      role="dialog"
      aria-labelledby="wonder-list-modal"
      aria-hidden="true"
    >
      <div className="modal-dialog modal-dialog-centered" role="document">
        <div className="modal-content">
          <div
            className="custom__modal__content"
            style={{ borderRadius: '10px', border: '2px solid #7687c2' }}
          >
            <ModalHeader>
              <h1>Select a wonder</h1>
              <a
                href=""
                className="custom__modal__close"
                data-dismiss="modal"
                aria-label="Close modal"
              >
                <img src="/img/plus-icon.svg" alt="Close" />
              </a>
            </ModalHeader>
            <ModalBody>
              <WonderLineSteps>
                {WonderSteps.map((step, idx) => (
                  <Step
                    className="step"
                    onClick={() => {
                      setSelectedStep(idx);
                      hideModal('wonder-list-modal');
                    }}
                    key={step.type}
                  >
                    {step.icon}
                    <p>{step.title}</p>
                  </Step>
                ))}
              </WonderLineSteps>
            </ModalBody>
          </div>
        </div>
      </div>
    </div>
  );

  if (typeof document === 'undefined') return null;

  return ReactDOM.createPortal(modalContent, document.body);
};

export default WonderListModal;
